import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 16.5L17.5 16.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round",
			strokeDasharray: "1 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 13L19 16.5L15.5 20",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 7.5H5.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 16.5H13",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 7.5L6.5 7.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round",
			strokeDasharray: "1 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 11L5 7.5L8.5 4",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTransactions;
